import React from 'react';

const ToggleSwitch = ({ name, checked, handleChange,cash_prize_amount }) => {
  return (
    <>
    <div>
    <label className="flex items-center gap-4 md:gap-0 cursor-pointer">
      <input
        type="checkbox"
        name={name} // Use the name prop for the checkbox
        className="sr-only peer"
        checked={checked} // Bind the checkbox to the checked prop
        onChange={handleChange} // Call handleChange on change
      />
      {/* <span className="text-sm md:min-w-52 font-medium text-black inter">
        {name === 'joinAfterStart' ? 'Join League after Start' : 'Private Portfolio'}
      </span> */}
            <span className="text-sm md:min-w-52 font-medium text-black inter">
        {name === "joinAfterStart"
          ? "Join League after Start"
          : name === "privatePortfolio"
          ? "Private Portfolio"
          : "Cash Prize League"} {/* Handle cashLeague */}
      </span>
      <div
        className={`relative w-12 h-7 bg-[#E6ECF1] rounded-full after:h-5 after:w-5 after:top-1 after:start-[2px]
                    ${checked ? 'bg-green-100' : 'bg-gray-200'}
                    peer-checked:after:translate-x-full
                    rtl:peer-checked:after:-translate-x-full
                    peer-checked:after:border-[#1D5157]
                    after:content-[''] after:absolute
                     after:start-[4px]
                    after:bg-[#1D5157] after:border-gray-300
                    after:border after:rounded-full
                     after:transition-all
                    dark:border-gray-600`}
      ></div>
    </label>



    </div>
    {/* Show the input box if cashLeague is checked */}
      {name === "cashLeague" && checked && (
        <div className='w-full flex items-center mt-10'>
        <label for="gameType" class="block md:min-w-52 text-sm font-medium text-black inter">Cash Prize Amount:</label>
        <input
          name='cash_prize_amount'
          value={cash_prize_amount || ""}
          type="number"
          min="1"
          onChange={handleChange} // Update state when typing
          className="p-2 border border-gray-300 rounded-md w-full md:w-60 ml-18"
          placeholder="Enter Cash Prize Amount"
        />
        </div>
      )}
      </>

  );
};

export default ToggleSwitch;
